import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Investors\AssetPositionController::store
* @see app/Http/Controllers/Investors/AssetPositionController.php:15
* @route '//app.finesthub.de/credit/{naturalPerson}/asset-positions'
*/
export const store = (args: { naturalPerson: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '//app.finesthub.de/credit/{naturalPerson}/asset-positions',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Investors\AssetPositionController::store
* @see app/Http/Controllers/Investors/AssetPositionController.php:15
* @route '//app.finesthub.de/credit/{naturalPerson}/asset-positions'
*/
store.url = (args: { naturalPerson: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { naturalPerson: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { naturalPerson: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            naturalPerson: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        naturalPerson: typeof args.naturalPerson === 'object'
        ? args.naturalPerson.id
        : args.naturalPerson,
    }

    return store.definition.url
            .replace('{naturalPerson}', parsedArgs.naturalPerson.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\AssetPositionController::store
* @see app/Http/Controllers/Investors/AssetPositionController.php:15
* @route '//app.finesthub.de/credit/{naturalPerson}/asset-positions'
*/
store.post = (args: { naturalPerson: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Investors\AssetPositionController::update
* @see app/Http/Controllers/Investors/AssetPositionController.php:33
* @route '//app.finesthub.de/credit/{naturalPerson}/asset-positions/{assetPosition}'
*/
export const update = (args: { naturalPerson: string | number | { id: string | number }, assetPosition: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number }, assetPosition: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put","patch"],
    url: '//app.finesthub.de/credit/{naturalPerson}/asset-positions/{assetPosition}',
} satisfies RouteDefinition<["put","patch"]>

/**
* @see \App\Http\Controllers\Investors\AssetPositionController::update
* @see app/Http/Controllers/Investors/AssetPositionController.php:33
* @route '//app.finesthub.de/credit/{naturalPerson}/asset-positions/{assetPosition}'
*/
update.url = (args: { naturalPerson: string | number | { id: string | number }, assetPosition: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number }, assetPosition: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            naturalPerson: args[0],
            assetPosition: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        naturalPerson: typeof args.naturalPerson === 'object'
        ? args.naturalPerson.id
        : args.naturalPerson,
        assetPosition: typeof args.assetPosition === 'object'
        ? args.assetPosition.id
        : args.assetPosition,
    }

    return update.definition.url
            .replace('{naturalPerson}', parsedArgs.naturalPerson.toString())
            .replace('{assetPosition}', parsedArgs.assetPosition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\AssetPositionController::update
* @see app/Http/Controllers/Investors/AssetPositionController.php:33
* @route '//app.finesthub.de/credit/{naturalPerson}/asset-positions/{assetPosition}'
*/
update.put = (args: { naturalPerson: string | number | { id: string | number }, assetPosition: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number }, assetPosition: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Investors\AssetPositionController::update
* @see app/Http/Controllers/Investors/AssetPositionController.php:33
* @route '//app.finesthub.de/credit/{naturalPerson}/asset-positions/{assetPosition}'
*/
update.patch = (args: { naturalPerson: string | number | { id: string | number }, assetPosition: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number }, assetPosition: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Investors\AssetPositionController::destroy
* @see app/Http/Controllers/Investors/AssetPositionController.php:42
* @route '//app.finesthub.de/credit/{naturalPerson}/asset-positions/{assetPosition}'
*/
export const destroy = (args: { naturalPerson: string | number | { id: string | number }, assetPosition: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number }, assetPosition: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '//app.finesthub.de/credit/{naturalPerson}/asset-positions/{assetPosition}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Investors\AssetPositionController::destroy
* @see app/Http/Controllers/Investors/AssetPositionController.php:42
* @route '//app.finesthub.de/credit/{naturalPerson}/asset-positions/{assetPosition}'
*/
destroy.url = (args: { naturalPerson: string | number | { id: string | number }, assetPosition: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number }, assetPosition: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            naturalPerson: args[0],
            assetPosition: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        naturalPerson: typeof args.naturalPerson === 'object'
        ? args.naturalPerson.id
        : args.naturalPerson,
        assetPosition: typeof args.assetPosition === 'object'
        ? args.assetPosition.id
        : args.assetPosition,
    }

    return destroy.definition.url
            .replace('{naturalPerson}', parsedArgs.naturalPerson.toString())
            .replace('{assetPosition}', parsedArgs.assetPosition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\AssetPositionController::destroy
* @see app/Http/Controllers/Investors/AssetPositionController.php:42
* @route '//app.finesthub.de/credit/{naturalPerson}/asset-positions/{assetPosition}'
*/
destroy.delete = (args: { naturalPerson: string | number | { id: string | number }, assetPosition: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number }, assetPosition: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const AssetPositionController = { store, update, destroy }

export default AssetPositionController